import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import {
  AlertWarningModule,
  ButtonModule,
  FormAlertModule,
  InputModule
} from '@com-delta-idp/mnx-ui-kit';
import { LoginHeaderModule } from '../../shared/login-header/login-header.module';
import { LogoHeaderModule } from '../../shared/logo-header/logo-header.module';
import { ForgotLoginComponent } from './forgot-login.component';

@NgModule({
  declarations: [ForgotLoginComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LoginHeaderModule,
    LogoHeaderModule,
    ButtonModule,
    InputModule,
    AlertWarningModule,
    FormAlertModule
  ],
  exports: [ForgotLoginComponent, LoginHeaderModule, LogoHeaderModule],
  providers: [FormGroupDirective]
})
export class ForgotLoginModule {}
